export const JourneySection = {
  incompleted: 'incompleted',
  upcoming: 'upcoming',
  modules: 'modules',
  past: 'past',
  bookable: 'bookable',
};
